import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import siteData from "../data/siteData.json";

const links = [
  { to: "/", label: "HOME" },
  { to: "/about", label: "ABOUT US" },
  { to: "/news", label: "NEWS" },
  { to: "/careers", label: "CAREERS" },
  { to: "/contact", label: "CONTACT US" },
];

const projectLinks = [
  { to: "/ongoing-project", label: "Ongoing Projects" },
  { to: "/complete-project", label: "Completed Projects" },
  { to: "/upcoming-project", label: "Upcoming Projects" },
];

function Navbar() {
  const location = useLocation();
  const { pathname } = location;
  const { company } = siteData;
  const projectsActive =
    pathname.startsWith("/projects") ||
    pathname.startsWith("/ongoing-project") ||
    pathname.startsWith("/complete-project") ||
    pathname.startsWith("/upcoming-project");

  useEffect(() => {
    let nav = document.querySelector("#mynav");
    const onScroll = () => {
      if (!nav) return;
      if (window.pageYOffset > 0) {
        nav.classList.add("sticky-top");
      } else {
        nav.classList.remove("sticky-top");
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const nav = document.getElementById("navbarSupportedContent");
    if (nav && nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  }, [location]);

  return (
    <nav className="navbar fixed-top navbar-expand-lg" id="mynav">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/">
          <img src="/img/logo.png" className="logo" alt="Shree Mahavir Group" />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>
        <div
          className="collapse navbar-collapse mr-auto w-100 justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            {links.slice(0, 2).map((l) => {
              const active =
                l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
              return (
                <li
                  key={l.to}
                  className={`nav-item${active ? " active" : ""}`}
                >
                  <NavLink className="nav-link" to={l.to}>
                    {l.label}
                    {active ? <span className="sr-only">(current)</span> : null}
                  </NavLink>
                </li>
              );
            })}
            <li className="nav-item dropdown">
              <NavLink
                className={`nav-link dropdown-toggle${
                  projectsActive ? " active" : ""
                }`}
                to="/projects"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                PROJECTS
              </NavLink>
              <ul className="dropdown-menu">
                {projectLinks.map((p) => (
                  <li key={p.to}>
                    <NavLink className="dropdown-item" to={p.to}>
                      {p.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
            {links.slice(2).map((l) => {
              const active =
                l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
              return (
                <li
                  key={l.to}
                  className={`nav-item${active ? " active" : ""}`}
                >
                  <NavLink className="nav-link" to={l.to}>
                    {l.label}
                    {active ? <span className="sr-only">(current)</span> : null}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
        <a
          className="number"
          href={company.phoneHref}
          style={{ whiteSpace: "nowrap" }}
        >
          <i className="fa fa-phone"></i> {company.phone}
        </a>
      </div>
    </nav>
  );
}

export default Navbar;